// extracted by mini-css-extract-plugin
export default {"buttonDelete":"style_buttonDelete__0ItPJ"};